var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDiscreetMailBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.653 8.83 27.581.888C27.298.363 26.734 0 26.129 0H5.726c-.605 0-1.17.323-1.452.887L.202 8.831A1.51 1.51 0 0 0 0 9.556v18.831C0 29.274.726 30 1.613 30h28.589c.887 0 1.612-.726 1.612-1.613V9.597c0-.282-.04-.524-.16-.766Zm-4.072-.846H17.54V3.226h7.62l2.42 4.758ZM6.694 3.226h7.62v4.758H4.275l2.42-4.758Zm21.895 23.548H3.266V11.21H28.63v15.564h-.04Z",
    fill: "#2FAEF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.37 17.944H10.444v3.225h10.928v-3.226Z",
    fill: "#2FAEF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiscreetMailBox);
export default __webpack_public_path__ + "static/media/icon_discreet_mail_box.40f5e26c99cf3cf5f3962f106de7606b.svg";
export { ForwardRef as ReactComponent };